export function registerTypografToggle(editor, iconUrl) {
  editor.addCommand('toggleTypograf', {
    exec: function(editor) {
      editor._typografDisabled = !editor._typografDisabled
      var button = editor.ui.get('TypografToggle')
      var el = button && button._ && button._.id ? document.getElementById(button._.id) : null
      if (el) el.classList.toggle('cke_button_on', editor._typografDisabled)
    }
  })
  editor.ui.addButton('TypografToggle', {
    label: 'Игнорировать типограф',
    command: 'toggleTypograf',
    toolbar: 'typograf',
    icon: iconUrl
  })
}
